const basePath = import.meta.env.BASE_URL;
const serverPath = '/' || window.location.host;
var reportedStatusToConsole = false;
export async function fetchData(fileName) {
	if (!reportedStatusToConsole) {
		console.log(import.meta.env.DEV ? 'built for dev' : 'built for prod');
		reportedStatusToConsole = true;
	}

	return fetch(`/study/data/${fileName}`)
		.then(response => {
			if (!response.ok) {
				throw new Error(`Failed to fetch ${fileName} from ${basePath}/data/${fileName}: ${response.statusText}`);
			}
			return response.json();
		})
		.catch(error => {
			console.error(error);
			return null;
		});
}

export async function fetchAllData() {
	// // const fileNames = [
	// // 	'serviceMessages.json',
	// // 	'foundationalKnowledge.json',
	// // 	'technique.json',
	// // 	'vocabulary.json',
	// // 	'caseStudies.json',
	// // 	'articles.json',
	// // 	'emotionEmpathy.json',
	// // 	'intuitionPsychology.json',
	// // 	'brandVisualDesign.json',
	// // 	'interviewPrep.json',
	// // 	'leadership.json',
	// // 	'keepLearning.json'
	// // ];

	// const contentFiles = {};

	// for (const fileName of fileNames) {
	// 	contentFiles[fileName.replace('.json', '')] = await fetchData(`${fileName}`);
	// }

	// return contentFiles;

	return await fetchData('allArticleData.json');
}

// generate corrected image URLs
export function fetchImage(imageName) {
	return `/study/img/${imageName}`;
}

// retrieve anything in the bjco-server/public/ folder
// paths will start from the server root
// eg: brownjuice.co/ or localhost:3000/

// retrieve a text file
export function fetchAsset(assetPathAndName) {
	console.log('fetching ',assetPathAndName);
	return fetch(`${serverPath}${assetPathAndName}`).then(response => {
		if (!response.ok) {
			throw new Error(`Failed to fetch ${assetPathAndName}: ${response.statusText}`);
		}
		return response.text();
	})
	.catch(error => {
		console.error(error);
		return null;
	});
}

// retrieve a blob file
export function fetchBlob(blobPathAndName) {
	return fetch(`${serverPath}${blobPathAndName}`).then(response => {
		if (!response.ok) {
			throw new Error(`Failed to fetch ${blobPathAndName}: ${response.statusText}`);
		}
		return response.blob();
	})
	.catch(error => {
		console.error(error);
		return null;
	});
}
// Example usage
// <template>
//   <img v-if="imageSrc" :src="imageSrc" alt="Fetched image" />
// </template>
//
// <script setup>
// import { ref, onMounted } from 'vue';
// import { fetchImage } from '../loadData';
//
// const imageSrc = ref(null);
//
// onMounted(async () => {
//   const blob = await fetchImage('example.jpg');
//   if (blob) {
//     imageSrc.value = URL.createObjectURL(blob);
//   }
// });
// </script>
